<palantir-accordion [title]="definition().label" [open]="true">
  @if (canShowFilter()) {
    <div class="date-input__container">
      @if (definition().description?.length) {
        <palantir-text size="base" type="description">{{ definition().description }}</palantir-text>
      }
      <div class="date-input__row">
        <palantir-text class="date-input__row__label">{{ definition().from.label }}</palantir-text>

        <palantir-input suffix="calendar-outline" class="date-input__input">
          <input
            [type]="definition().includeTime ? 'datetime-local' : 'date'"
            [placeholder]="definition().from.placeholder ?? ''"
            [formControl]="fromControl"
          />
          <palantir-filter-modal-error-display
            palantir-input-error
            [control]="fromControl"
            [validatorsMessages]="definition().from.validatorsMessages"
          />
        </palantir-input>
      </div>

      <div class="date-input__row">
        <palantir-text class="date-input__row__label">{{ definition().to.label }}</palantir-text>

        <palantir-input suffix="calendar-outline" class="date-input__input">
          <input
            [type]="definition().includeTime ? 'datetime-local' : 'date'"
            [placeholder]="definition().to.placeholder ?? ''"
            [formControl]="toControl"
          />
          <palantir-filter-modal-error-display
            palantir-input-error
            [control]="toControl"
            [validatorsMessages]="definition().to.validatorsMessages"
          />
        </palantir-input>
      </div>
    </div>
  } @else {
    <div class="filter-dialog__banner">
      <palantir-icon name="info-outline" class="filter-dialog__banner__icon" />
      <palantir-text size="base" type="description">{{
        definition().dependsOn?.placeholder
      }}</palantir-text>
    </div>
  }
</palantir-accordion>
